import React, { Component } from "react";
// OPEN LAYERS
import VectorLayer from "ol/layer/Vector";
import { Vector as VectorSource } from "ol/source.js";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";
import Geometry from 'ol/geom/Geometry';
import cloneDeep from 'lodash/cloneDeep';

class FeatureRendering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      featureVisibility: true,
    };

    window.emitter.addListener(
      "renderFeature",
      (feature, layerName, tabName, id, source, visibility, customColor) =>
        this.renderFeature(
          feature,
          layerName,
          tabName,
          id,
          source,
          visibility,
          customColor
        )
    );
    window.emitter.addListener(
      "removeRenderedFeature",
      (type, layername, source) =>
        this.removeRenderedFeature(type, layername, source)
    );
    window.emitter.addListener("highlightOnMap", (feature, layerName) =>
      this.highlightOnMap(feature, layerName)
    );
    window.emitter.addListener("removeRowHighlight", () =>
      this.removeRowHighlight()
    );
  }

  componentDidMount() {
    window.emitter.emit("closePopup");
    this.initialize(this.state.featureVisibility);
  }

  getColorStyles = (customColor, feature) => {
    const defaultStyles = {
      fillColor: "#1347AE7F",
      strokeColor: "#1347AE7F",
      circleFillColor: "#1347AE7F",
      circleStrokeColor: "#1347AE7F",
      strokeWidth: 2
    };

    let geometryType;
    if (Array.isArray(feature)) {
      if (feature.length > 0 && feature[0].getGeometry && feature[0].getGeometry()) {
        geometryType = feature[0].getGeometry().getType();
      } else {
        console.log("Nie sú definované žiadne features alebo ich geometria v poli");
        return defaultStyles;
      }
    } else if (feature && typeof feature.getGeometry === 'function' && feature.getGeometry()) {
      geometryType = feature.getGeometry().getType();
    } else {
      console.log("Feature alebo jeho geometria nie sú definované");
      return defaultStyles;
    }

    // Přizpůsobení defaultních stylů podle typu geometrie
    if (!customColor) {
      if (geometryType === 'LineString' || geometryType === 'MultiLineString') {
        return {
          ...defaultStyles,
          strokeWidth: 3
        };
      } else {
        return defaultStyles;
      }
    }
    
    // Zpracování vlastní barvy
    const matches = customColor.match(/(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
    if (!matches) return defaultStyles;

    const [r, g, b, a = 0.4] = matches.slice(1);
    let strokeColor = geometryType === 'LineString' || geometryType === 'MultiLineString'
      ? `rgba(${r}, ${g}, ${b}, 1)`
      : "rgba(0, 0, 0, 0.8)";
    const fillColor = `rgba(${r}, ${g}, ${b}, ${a})`;
    let strokeWidth = geometryType === 'LineString' || geometryType === 'MultiLineString'
      ? 3
      : 2;

    return {
      ...defaultStyles,
      fillColor,
      strokeColor,
      circleFillColor: fillColor,
      circleStrokeColor: strokeColor,
      strokeWidth
    };
  };

  initialize = (visibility, feature, customColor) => {

    const { fillColor, strokeColor, circleFillColor, circleStrokeColor, strokeWidth } = this.getColorStyles(customColor, feature);

    if (!visibility) {
      fillColor = strokeColor = circleFillColor = circleStrokeColor = "rgba(0, 0, 0, 0.0)";
    }

    this.setupVectorLayer(fillColor, strokeColor, strokeWidth, circleFillColor, circleStrokeColor);
    this.setupHighlightLayer();
    this.setupHighlightPointLayer();
  };

  setupVectorLayer = (fillColor, strokeColor, strokeWidth, circleFillColor, circleStrokeColor) => {
    this.vectorSource = new VectorSource();
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      zIndex: 500,
      style: new Style({
        fill: new Fill({ color: fillColor }),
        stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({ color: circleFillColor }),
          stroke: new Stroke({ color: circleStrokeColor, width: 1 }),
        }),
      }),
    });
  };

  setupHighlightLayer = () => {
    this.vectorSourceHighlight = new VectorSource();
    this.vectorLayerHighlight = new VectorLayer({
      source: this.vectorSourceHighlight,
      zIndex: 4,
      style: function (feature) {
        let geometryType = feature.getGeometry().getType();
        let strokeColor = (geometryType === 'LineString' || geometryType === 'MultiLineString')
          ? [255, 255, 0, 1]
          : [0, 0, 0, 1];
        let strokeWidth = geometryType === 'LineString' || geometryType === 'MultiLineString'
          ? 7
          : 1;

        return new Style({
          fill: new Fill({ color: [255, 255, 0, 0.5] }),
          stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({ color: [255, 255, 0, 1] }),
            stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
          }),
        });
      },
    });
  };

  setupHighlightPointLayer = () => {
    this.vectorSourceHighlightPoint = new VectorSource();
    this.vectorLayerHighlightPoint = new VectorLayer({
      source: this.vectorSourceHighlightPoint,
      zIndex: 10000,
      style: new Style({
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({ color: [255, 255, 0, 1] }),
          stroke: new Stroke({ color: [0, 0, 0, 1], width: 1 }),
        }),
      }),
    });
  };

  renderFeature = (
    feature,
    layerName,
    tabName,
    id,
    source,
    visibility,
    customColor
  ) => {

    // if (!feature || !feature.getGeometry()) {
    //   console.error("Invalid feature or missing geometry.");
    //   return;
    // }
  
    window.emitter.emit("closePopup");
    window.emitter.emit("cleanUpSearch");

    // Hlboké klonovanie feature
    let clonedFeature = cloneDeep(feature);

    this.initialize(visibility, clonedFeature, customColor);

    // tabName in searchComponent
    if (source === "searchComponent") {
      tabName = layerName + "_" + tabName;
      // clonedFeature["tabName"] = layer.values_.displayName;?
    }
    let name = source === "prevRes" ? id : tabName;
    if (!clonedFeature || clonedFeature.length === 0) return;

    const isArray = Array.isArray(clonedFeature);
    const isFromTOC = source === "toc";
    const isFromURI = source === "uri";
    const isFromKN = source === "kn";

    const isRendered = visibility === false ? false : true;
    this.vectorLayer.setProperties({ isRendered: isRendered });

    if (!isArray) clonedFeature = [clonedFeature];

    clonedFeature.forEach((feat) => {
      const geometry = feat.getGeometry();
      if (!geometry || !(geometry instanceof Geometry)) {
          console.error("Invalid geometry for feature:", feat);
          return;
      }
      feat["layerName"] = layerName;
      feat["tabName"] = tabName;
      feat["layerSource"] = source;
      feat["isRendered"] = isRendered;
  
      if (!isFromTOC && !isFromURI && !isFromKN) {
          feat["id_"] = [tabName, feat["id_"]].join("-uid-");
      }
  });
  
    this.vectorLayer.set("name", "fr_" + source + "_" + name);
    window.map.addLayer(this.vectorLayer);
    this.vectorLayer.getSource().addFeatures(clonedFeature);

    let extent = this.vectorLayer.getSource().getExtent();
    if (extent && extent.every((val) => !isNaN(val) && val !== Infinity && val !== -Infinity)) {
        if (visibility) {
            window.map.getView().fit(extent, window.map.getSize(), { duration: 500 });
            const zoomValue = window.map.getView().getZoom();
            const newZoom = this.calcNewZoom(zoomValue);
            window.map.getView().setZoom(newZoom);
        }
    } else {
        console.warn("Invalid extent for vectorLayer. Skipping fit operation.");
    }
    
  };

  calcNewZoom = (zoomValue) => {
    let newZoom = undefined;

    if (zoomValue > 4 && zoomValue <= 13) {
      newZoom = zoomValue - 1;
    } else if (zoomValue > 13 && zoomValue <= 14) {
      newZoom = zoomValue - 2;
    } else if (zoomValue > 14 && zoomValue <= 16) {
      newZoom = zoomValue - 3;
    } else if (zoomValue > 16 && zoomValue <= 17) {
      newZoom = zoomValue - 3;
    } else if (zoomValue > 17) {
      newZoom = zoomValue - 8;
    } else {
      newZoom = zoomValue - 0.5;
    }

    // Pridanie podmienky na obmedzenie zoom hodnoty
    // if (newZoom > 8.5) {
    //     newZoom = 8.5;
    // }
    if (newZoom > 11) {
        newZoom = 11;
    }

    return newZoom;
};


  highlightOnMap = (features, layerName) => {

    window.emitter.emit("cleanUpSearch");

    if (!Array.isArray(features)) {
      features = [features];
    }

    this.vectorLayerHighlight.getSource().clear();

    let isLineStringOrMultiLineString = false;

    for (const feature of features) {
      let geomType = null;
      if (feature && typeof feature.getGeometry === 'function' && feature.getGeometry()) {
        geomType = feature.getGeometry().getType();
      }

      if (!geomType) {
        console.warn("geomType is not available");
        continue;
      }

      if (geomType === 'LineString' || geomType === 'MultiLineString') {
        isLineStringOrMultiLineString = true;
      }

      let clonedFeature = feature.clone();
      clonedFeature.set('layerName', layerName);
      this.vectorLayerHighlight.getSource().addFeature(clonedFeature);
    }

    this.vectorLayerHighlight.setProperties({ isRendered: true });
    this.vectorLayerHighlight.set("name", `fr_highlight_${layerName}`);

    if (!isLineStringOrMultiLineString) {
      const layers = window.map.getLayers().getArray();
      const highestZIndex = layers.reduce((max, layer) => Math.max(max, layer.getZIndex() || 0), 0);
      this.vectorLayerHighlight.setZIndex(highestZIndex + 1);
    }

    if (!window.map.getLayers().getArray().includes(this.vectorLayerHighlight)) {
      window.map.addLayer(this.vectorLayerHighlight);
    }
  };

  removeRowHighlight = () => {
    // first all rows to transparent
    var tabRows_transparent = document.getElementsByClassName("tr"),
      index_t = tabRows_transparent.length;
    while (index_t--) {
      tabRows_transparent[index_t].className = "tr transparent-color";
    }
    // all rows to white color
    var tabRows_white = document.getElementsByClassName("td"),
      index_w = tabRows_white.length;
    while (index_w--) {
      tabRows_white[index_w].className = "td white-color";
    }
  };

  removeRenderedFeature = (type, layerName, source) => {

    const layers = window.map.getLayers().getArray();

    switch (type) {
      case "bothByLayerName":
        // layers
        //   .filter((layer) => {
        //     const name = layer?.get("name");

        //     return name && name.match(new RegExp(`^fr_${source}_${layerName}`));
        //     // return name && name.match(new RegExp(`^fr_${source}_${layerName}`));
        //   })
        //   .forEach((layer) => window.map.removeLayer(layer));

        layers
          .filter((layer) => {
            const name = layer?.get("name");

            return name && name.match(new RegExp(layerName));
          })
          .forEach((layer) => window.map.removeLayer(layer));

        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return name && name.match(new RegExp(`^fr_highlight_${layerName}`));
          })
          .forEach((layer) => window.map.removeLayer(layer));

        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return (
              name && name.match(new RegExp(`^fr_highlight_point_${layerName}`))
            );
          })
          .forEach((layer) => window.map.removeLayer(layer));
        break;

      case "bothBySource":
        layers
          .filter((layer) => {
            const name = layer?.get("name");
            const sourceRegex = Array.isArray(source)
              ? new RegExp(`^fr_(${source.join('|')})`)
              : new RegExp(`^fr_${source}`);
            return name && name.match(sourceRegex);
          })
          .forEach((layer) => window.map.removeLayer(layer));


        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return name && name.match(/^fr_highlight/);
          })
          .forEach((layer) => window.map.removeLayer(layer));

        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return name && name.match(/^fr_highlight_point_/);
          })
          .forEach((layer) => window.map.removeLayer(layer));
        break;

      case "allHighlights":
        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return name && name.match(/^fr_highlight/);
          })
          .forEach((layer) => window.map.removeLayer(layer));

        // layers
        //   .filter((layer) => {
        //     const name = layer?.get("name");
        //     return name && name.match(/^fr_filter_highlight/);
        //   })
        //   .forEach((layer) => window.map.removeLayer(layer));

        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return name && name.match(/^fr_highlight_point_/);
          })
          .forEach((layer) => window.map.removeLayer(layer));
        break;

      case "highlightByLayerName":
        layers
          .filter((layer) => {
            const name = layer?.get("name");
            return (
              name && name.match(new RegExp(`^(fr_highlight_${layerName})`))
            );
          })
          .forEach((layer) => window.map.removeLayer(layer));

        break;

      case "byLayerName":
        layers
          .filter((layer) => layer?.get("name") === layerName)
          .forEach((layer) => window.map.removeLayer(layer));
        break;

      default:
        console.log("default case");
        break;
    }
  };

  render() {
    return <div></div>;
  }
}

export default FeatureRendering;
